var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Logo from '../../../Logo';
const LogoSmartCard = (_a) => {
    var commonProps = __rest(_a, []);
    const source = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#EA581F" }),
            React.createElement("path", { d: "M18.2 9.40002H9.94995C8.94995 9.40002 8.19995 8.60002 8.19995 7.65002C8.19995 6.65002 8.99995 5.90002 9.94995 5.90002H18.2C19.2 5.90002 19.95 6.70002 19.95 7.65002C19.95 8.60002 19.15 9.40002 18.2 9.40002Z", fill: "white" }),
            React.createElement("path", { d: "M14.05 17.65H5.80005C4.80005 17.65 4.05005 16.85 4.05005 15.9C4.05005 14.9 4.85005 14.15 5.80005 14.15H14.05C15.05 14.15 15.8 14.95 15.8 15.9C15.85 16.9 15.05 17.65 14.05 17.65Z", fill: "white" }),
            React.createElement("path", { d: "M18.05 13.55H5.80005C4.80005 13.55 4.05005 12.75 4.05005 11.8C4.05005 10.8 4.85005 10.05 5.80005 10.05H18.05C19.05 10.05 19.8 10.85 19.8 11.8C19.85 12.75 19.05 13.55 18.05 13.55Z", fill: "white" }))),
        alt: 'Smart Card',
    };
    return React.createElement(Logo, Object.assign({}, commonProps, { source: source }));
};
export default LogoSmartCard;
//# sourceMappingURL=index.js.map